import { adminApi, publicApi } from './http';

export const DEFAULT_SITE_SETTINGS = {
  siteName: '晴屿集',
  logoUrl: '/assets/site-logo.svg',
  homeHeroImageUrl: '',
  backgroundImageUrl: '',
};

export const normalizeSiteSettings = (settings = {}) => ({
  siteName: settings.siteName || DEFAULT_SITE_SETTINGS.siteName,
  logoUrl: settings.logoUrl || DEFAULT_SITE_SETTINGS.logoUrl,
  homeHeroImageUrl: settings.homeHeroImageUrl || '',
  backgroundImageUrl: settings.backgroundImageUrl || '',
  updatedAt: settings.updatedAt || '',
});

export const fetchPublicSiteSettings = () => publicApi.get('/site-settings');

export const fetchAdminSiteSettings = () => adminApi.get('/site-settings');

export const updateAdminSiteSettings = ({
  siteName,
  logoUrl,
  homeHeroImageUrl,
  backgroundImageUrl,
  logo,
  homeHeroImage,
  backgroundImage,
}) => {
  const formData = new FormData();

  formData.append('siteName', siteName || '');
  formData.append('logoUrl', logoUrl || '');
  formData.append('homeHeroImageUrl', homeHeroImageUrl || '');
  formData.append('backgroundImageUrl', backgroundImageUrl || '');

  if (logo) {
    formData.append('logo', logo);
  }
  if (homeHeroImage) {
    formData.append('homeHeroImage', homeHeroImage);
  }
  if (backgroundImage) {
    formData.append('backgroundImage', backgroundImage);
  }

  return adminApi.put('/site-settings', formData, {
    timeout: 60000,
  });
};
